export { default as DefaultPage } from './DefaultPage';
export { default as FormAttrEdit } from './FormAttrEdit';



// WEBPACK FOOTER //
// ./src/features/formedit/index.js